import utils from "../../../utils/utils.js";

export default {
  async fetchWorkspaceAiIsEnabled(context) {
    const response = await utils.utility.fetch(
      `api/Setting/GetWorkspaceAiIsEnabled`,
      "GET",
      null,
      null
    );
    context.commit("setWorkspaceAiIsEnabled", response.data);
  },

  async changeWorkspaceAiIsEnabled(context, payload) {
    await utils.utility.fetch(
      `api/Setting/ChangeEngagementWorkspaceAiIsEnabled`,
      "POST",
      null,
      { isEnabled: payload.isEnabled }
    );
    context.commit("setWorkspaceAiIsEnabled", payload.isEnabled);
  },
};
